import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';
import ConfigManager from '../../vendor_core/core/src/managers/ConfigManager';
import IAdvanceGeneralGameConfig from '../../vendor_core/core/src/managers/contracts/configurations/game/IAdvanceGeneralGameConfig';
import ISettingsConfig from '../../vendor_core/core/src/managers/contracts/configurations/ISettingsConfig';
import IRulesScenes from '../../vendor_core/core/src/managers/contracts/configurations/settings/IRulesScenes';
import ISettingsRulesData from '../../vendor_core/core/src/managers/contracts/configurations/settings/ISettingsRulesData';
import GameModel from '../../vendor_core/core/src/model/GameModel';
import IVendorClientConfigRequestData from '../../vendor_core/src/server/requests/contracts/IVendorClientConfigRequestData';
import Configs from '../../vendor_core/src/vendorConfigs/Configs';

class SettingsConfig implements ISettingsConfig {
    type: ConfigurationTypes = ConfigurationTypes.SETTINGS;
    rulesScenes: IRulesScenes = {
        paytable: "paytable",
        gameRules: "gamerules",
        gameInfo: "gameinfo"
    };
    // biggestTextScene: string = "gamerules~1";
    // biggestTextTextField: string = "rules_pg_5";
    scenesForCalculatingMinFontSize: string[] = [
        "gamerules~1",
        "gamerules~2",
        "gamerules~3",
        "gamerules~4",
        "gamerules~5",
        "gameinfo~1",
        "gameinfo~2",
        "gameinfo~3",
        "gameinfo~4",
        "gameinfo~5"

    ];
    /**
     * @param name First part of the key for rules defined in localization (without the number of the end of the key)
     * @param rules This represents the rules which will be seen on one rules page in settings
     * - "from" (`rules[0]`) number of define in localization rules
     * - "to" (`rules[1]`) number of define in localization rules
     * @param sceneTextField This is the name of the body text field in PSD who is collecting all visible rules on one setting page
     */
    rulesData: ISettingsRulesData[] = [
        {
            name: "rules_pg_1_",
            rulesDimensions: [1, 1],
            sceneTextField: "rules_pg_1",
        },
        {
            name: "rules_pg_2_",
            rulesDimensions: [1, 2],
            sceneTextField: "rules_pg_2",
        },
        {
            name: "winways",
            rulesDimensions: [5, 5],
            sceneTextField: "winways",
        },
        //for dream drop version only
        // {
        //     name: "rules_pg_3_",
        //     rulesDimensions: [1, 1],
        //     sceneTextField: "rules_pg_3",
        // },
        // {
        //     name: "rules_pg_4_",
        //     rulesDimensions: [1, 1],
        //     sceneTextField: "rules_pg_4",
        // },
        {
            name: "gameinfo_pg_1_",
            rulesDimensions: [1, 11],
            sceneTextField: "gameinfo_pg_1",
        },
        {
            name: "gameinfo_pg_2_",
            rulesDimensions: [1, 8],
            sceneTextField: "gameinfo_pg_2",
        },
        {
            name: "gameinfo_pg_3_",
            rulesDimensions: [1, 1],
            sceneTextField: "gameinfo_pg_3",
        },
        {
            name: "gameinfo_pg_4_",
            rulesDimensions: [1, 5],
            sceneTextField: "gameinfo_pg_4",
        },
        {
            name: "gameinfo_pg_5_",
            rulesDimensions: [1, 2],
            sceneTextField: "gameinfo_pg_5",
        },
        {
            name:"gameinfo_pg_6_",
            rulesDimensions:[1,2],
            sceneTextField:"gameinfo_pg_6"
        },
        {
            name:"gameinfo_pg_10_",
            rulesDimensions:[1,1],
            sceneTextField:"gameinfo_pg_10"
        },
        {
            name:"gameinfo_date_pg_10_",
            rulesDimensions:[1,1],
            sceneTextField:"gameinfo_date_pg_10"
        }

    ];
    applyMinFontSizeTextFields: string[] = [
        // "ui_sounds",
        // "ui_music",
        // "ui_turbo",
    ];

    forceCalculateBoundFields?: string[] = [
        "ui_game_rules",
        "paytable_wild",
        "pt_free_spins"
    ];
    forceCalculateBoundScenes?: string[] = [
        "paytable~1",
        "paytable~2",
        "paytable~3",
        "paytable~4",
        "paytable~5",
        "winways",
        "gamerules~1",
        "gamerules~2",
        "gamerules~3",
        "gamerules~4",
        "gamerules~5"
    ];
    ptMap: { key: string; multiplier: number; }[] = [];


    hideWinWays() {
        return GameModel.jurisdiction !== 'DE';
    }

    hideAutoplayTexts() {
        return ConfigManager.getConfig<IAdvanceGeneralGameConfig<IVendorClientConfigRequestData>>(ConfigurationTypes.GAME).clientConfig.autoplayDisable;
    }

    hideGameInfoPg5_3() {
        const rtp = ConfigManager.getConfig<IAdvanceGeneralGameConfig<IVendorClientConfigRequestData>>(ConfigurationTypes.GAME).getRTP();
        return rtp !== 86;
    }

    hideFastPlayText() {
        return !ConfigManager.getConfig<IAdvanceGeneralGameConfig<IVendorClientConfigRequestData>>(ConfigurationTypes.GAME).clientConfig.quickStop;
    }

    textsToHide: { enabled: Function; keys: string[]}[] = [
        {enabled: this.hideAutoplayTexts, keys:["gameinfo_pg_1_6"]},
        {enabled: this.hideGameInfoPg5_3, keys:["gameinfo_pg_5_3"]},
        {enabled: this.hideFastPlayText, keys:["gameinfo_pg_1_7", "gameinfo_pg_1_8", "gameinfo_pg_1_9"]}
    ];

    hideBuyFeatureTexts() {
        return Configs.game.clientConfig.disableBuyFeature || !Configs.buyFeature.maxFeaturePurchasePrice;
    }

    hideScatterBoost() {
        const isRtp86 = ConfigManager.getConfig<IAdvanceGeneralGameConfig<IVendorClientConfigRequestData>>(ConfigurationTypes.GAME).getRTP() === 86;
        const isDeJusrisdiction = GameModel.jurisdiction === 'DE';
        return isRtp86 && isDeJusrisdiction;
    }

    pagesToHide: { enabled: Function; keys: string[] }[] = [
        {enabled: this.hideBuyFeatureTexts, keys:["paytable11", "paytable13"]},
        {enabled: this.hideScatterBoost, keys:["paytable10", "paytable12"]},
        {enabled: this.hideWinWays, keys:["winways"]},
    ];
}

export default new SettingsConfig()
